import * as React from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface LabelWithHoverProps {
  label: string;
  hoverContent?: React.ReactNode | null;
  showUnderline?: boolean;
  className?: string;
}

export function LabelWithHover({
  label,
  hoverContent,
  showUnderline = false,
  className,
}: LabelWithHoverProps) {
  if (!hoverContent) {
    return <span className={className}>{label}</span>;
  }
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={cn(
              "cursor-help",
              showUnderline && "border-b border-dashed border-current",
              className
            )}
          >
            {label}
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-[280px] max-h-[200px] overflow-y-auto text-sm">
          {hoverContent}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
